import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function PieceSubscriptionsChart({ data }) {
  // Chart.js v4 options syntax
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Number of pieces under subscription',
        font: {
          size: 20,
        },
      },
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        type: 'category',
        display: true,
        grid: {
          offset: false,
        },
        categoryPercentage: 0.2,
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
      },
    },
    maintainAspectRatio: false,
  };

  const chartData = {
    labels: data?.labels || [],
    datasets: [
      {
        label: 'Pieces',
        backgroundColor: '#5568ab',
        borderColor: '#5568ab',
        borderWidth: 1,
        data: data?.data || [],
      },
    ],
  };

  return (
    <div className="piece-subscription-chart chart">
      <div style={{ height: '400px', width: '800px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}

export default PieceSubscriptionsChart;
